import { render, staticRenderFns } from "./AddContainerDialog.vue?vue&type=template&id=964e7440&scoped=true&"
import script from "./AddContainerDialog.vue?vue&type=script&lang=js&"
export * from "./AddContainerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddContainerDialog.vue?vue&type=style&index=0&id=964e7440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964e7440",
  null
  
)

export default component.exports